import React from 'react';
import { Frown } from 'lucide-react';

/**
 * A simple 404 Not Found error page component.
 * @param {object} props - The component props.
 * @param {function} props.navigateTo - Function to navigate to a different page.
 */
const NotFoundPage = ({ navigateTo }) => {
  return (
    <div className="flex items-center justify-center min-h-[60vh] text-center p-4">
      <div className="bg-card-background p-8 rounded-xl shadow-lg max-w-lg w-full transform transition-all duration-500 ease-out animate-in fade-in-0 zoom-in-95">
        <div className="text-accent-main mb-6">
          <Frown className="w-24 h-24 mx-auto animate-bounce-slow" />
        </div>
        <h2 className="text-4xl md:text-5xl font-bold text-primary-dark mb-4">
          404 - Page Not Found
        </h2>
        <p className="text-lg text-text-muted mb-6">
          The page you are looking for doesn't exist or has been moved. Please
          check the URL or use the button below to return to the home page.
        </p>
        <button
          onClick={() => navigateTo('/')}
          className="bg-accent-main hover:bg-accent-hover text-white font-bold py-3 px-6 rounded-lg shadow-md transition duration-300"
        >
          Go to Homepage
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
